// src/redux/reducers/residualRiskReducer.js
import {
    GENERATE_RESIDUAL_RISK_START,
    GENERATE_RESIDUAL_RISK_SUCCESS,
    GENERATE_RESIDUAL_RISK_FAILURE,
    UPDATE_RESIDUAL_RISK,
    ANALYZE_ACTIONPLAN_START,
    ANALYZE_ACTIONPLAN_SUCCESS,
    ANALYZE_ACTIONPLAN_FAILURE,
    FETCH_RESIDUAL_RISK_START,
    FETCH_RESIDUAL_RISK_SUCCESS,
    FETCH_RESIDUAL_RISK_FAILURE,
  } from '../actions/actionTypes';
  
  const initialState = {
    byModel: {
    //   [modelId]: {
    //     [riskId]: {
    //       rating: null,
    //       explanation: '',
    //       loading: false,
    //       error: null,
    //     },
    //   },
    },
  };
  
  export default function residualRiskReducer(state = initialState, action) {
    switch (action.type) {
      case GENERATE_RESIDUAL_RISK_START: {
        const { modelId, riskId } = action.payload;
        return {
          ...state,
          byModel: {
            ...state.byModel,
            [modelId]: {
              ...state.byModel[modelId],
              [riskId]: {
                ...state.byModel[modelId]?.[riskId],
                loading: true,
                error: null,
              },
            },
          },
        };
      }
  
      case GENERATE_RESIDUAL_RISK_SUCCESS: {
        const { modelId, riskId, residual_rating, residual_explanation } = action.payload;
        const existing = state.byModel[modelId]?.[riskId] || {};
      
        return {
          ...state,
          byModel: {
            ...state.byModel,
            [modelId]: {
              ...state.byModel[modelId],
              [riskId]: {
                // Spread existing fields so we keep e.g. actionPlanRating, actionPlanAnalysis
                ...existing,
                // Overwrite with new rating/explanation
                residual_rating,
                residual_explanation,
                loading: false,
                error: null,
              },
            },
          },
        };
      }
  
      case GENERATE_RESIDUAL_RISK_FAILURE: {
        const { modelId, riskId, error } = action.payload;
        return {
          ...state,
          byModel: {
            ...state.byModel,
            [modelId]: {
              ...state.byModel[modelId],
              [riskId]: {
                loading: false,
                error,
              },
            },
          },
        };
      }

      case UPDATE_RESIDUAL_RISK: {
        const { modelId, riskId, overrideData } = action.payload;
        // overrideData = { rating, explanation, actionPlanRating }
        return {
          ...state,
          byModel: {
            ...state.byModel,
            [modelId]: {
              ...state.byModel[modelId],
              [riskId]: {
                ...state.byModel[modelId]?.[riskId],
                overridden: {
                residual_rating: overrideData.residual_rating,
                residual_explanation: overrideData.residual_explanation,
                action_plan_rating: overrideData.action_plan_rating,
              },
              },
            },
          },
        };
      }

          case ANALYZE_ACTIONPLAN_START: {
            const { modelId, riskId } = action.payload;
            return {
              ...state,
              byModel: {
                ...state.byModel,
                [modelId]: {
                  ...state.byModel[modelId],
                  [riskId]: {
                    ...state.byModel[modelId]?.[riskId],
                    actionPlanLoading: true,
                    actionPlanError: null,
                  },
                },
              },
            };
          }
      
          case ANALYZE_ACTIONPLAN_SUCCESS: {
            const { modelId, riskId, action_plan_rating, action_plan_analysis, action_plan_short_summary } = action.payload;
            const existing = state.byModel[modelId]?.[riskId] || {};
            return {
              ...state,
              byModel: {
                ...state.byModel,
                [modelId]: {
                  ...state.byModel[modelId],
                  [riskId]: {
                    ...existing,
                    action_plan_rating,
                    action_plan_analysis,
                    action_plan_short_summary,
                    actionPlanLoading: false,
                    actionPlanError: null,
                  },
                },
              },
            };
          }
      
          case ANALYZE_ACTIONPLAN_FAILURE: {
            const { modelId, riskId, error } = action.payload;
            return {
              ...state,
              byModel: {
                ...state.byModel,
                [modelId]: {
                  ...state.byModel[modelId],
                  [riskId]: {
                    ...state.byModel[modelId]?.[riskId],
                    actionPlanLoading: false,
                    actionPlanError: error,
                  },
                },
              },
            };
          }
          case FETCH_RESIDUAL_RISK_START: {
            // Assessment-centric: Key by assessmentUuid
            const { assessmentUuid } = action.payload;
            return {
              ...state,
              byModel: {
                ...state.byModel,
                [assessmentUuid]: {
                  ...state.byModel[assessmentUuid],
                  loading: true,
                },
              },
            };
          }

          case FETCH_RESIDUAL_RISK_SUCCESS: {
            // Assessment-centric: Key by assessmentUuid
            const { assessmentUuid, residualRisk } = action.payload;
            let riskData = {};
            if (Array.isArray(residualRisk)) {
              riskData = residualRisk.reduce((acc, row) => {
                acc[row.risk_id] = row;
                return acc;
              }, {});
            } else if (typeof residualRisk === 'object' && residualRisk !== null) {
              riskData = residualRisk;
            }
            return {
              ...state,
              byModel: {
                ...state.byModel,
                [assessmentUuid]: {
                  ...state.byModel[assessmentUuid],
                  ...riskData,
                  loading: false,
                  error: null,
                },
              },
            };
          }

          case FETCH_RESIDUAL_RISK_FAILURE: {
            // Assessment-centric: Key by assessmentUuid
            const { assessmentUuid, error } = action.payload;
            return {
              ...state,
              byModel: {
                ...state.byModel,
                [assessmentUuid]: {
                  ...state.byModel[assessmentUuid],
                  loading: false,
                  error,
                },
              },
            };
          }
      
  
      default:
        return state;
    }
  }